import { createContext, useContext } from 'react';

import { Config } from '@config/Config';
import { Environment, ShopBundle } from '@types-internal';
import { selectConfig } from '@utils/configUtils';

type ConfigContextData = {
  config: Config;
};

const ConfigContext = createContext<ConfigContextData>({
  config: {} as Config,
});

export const useConfig = () => useContext(ConfigContext);

interface ConfigContextProviderProps {
  env: Environment;
  shopBundle: ShopBundle;
}

const ConfigProvider: React.FC<ConfigContextProviderProps> = ({ env, children, shopBundle }) => {
  const config = selectConfig(env)(shopBundle);

  return <ConfigContext.Provider value={{ config }}>{children}</ConfigContext.Provider>;
};

export default ConfigProvider;
